import {Component, OnInit, EventEmitter, ViewEncapsulation, AfterViewInit} from '@angular/core';
import {DialogComponent, DialogService} from 'ng2-bootstrap-modal';
import {ModulesService} from '../../../_services/modules.service';
import {LineBotService} from '../../../_services/line-bot.service';
import {TelegramChannelService} from '../../../_services/telegram-channel.service';
import {ModulesModel} from '../../../_models/modules'
import {CategoryMoneyService} from '../../../_services/category-money.service';
import {Observable} from 'rxjs/Observable';
import {PopupShowListCoinComponent} from "../../send-signal-event/popup-show-list-coin/popup-show-list-coin.component";
import {SendSignalService} from "../../../_services/send-signal.service";

declare var $: any;

@Component({
    selector: 'app-edit-ios-app-user',
    templateUrl: './edit-modules.component.html',
    styleUrls: ['../add-modules/add-modules.component.css'],
    encapsulation: ViewEncapsulation.None
})

export class EditModulesComponent extends DialogComponent<ModulesModel, boolean> implements AfterViewInit, OnInit {

    model: any = {};
    loading = false;
    message: string;
    focusEventEmitter = new EventEmitter<boolean>();
    id: string;
    arrDataModule: any = [];
    categoryMoneyAlls: Observable<any[]>;
    getLineBot: Observable<any[]>;
    categoryMoney: number;
    constantModules: any;
    freeLineBotID: number;
    arrData: any = [];
    objPopUp: any;
    childModuleSendSignalEvents: any = [];
    functionSendSignalPrice: any = [];
    booleanSendSignalEvent: boolean = false;

    constructor(
        dialogService: DialogService,
        private modulesService: ModulesService,
        private categoryMoneyService: CategoryMoneyService,
        private lineBotService: LineBotService,
        private telegramChannelService: TelegramChannelService,
        private sendSignalService: SendSignalService) {
        super(dialogService);

        this.getLineBot = this.lineBotService.getLineBot();
        this.sendSignalService.getAllFunctionForUser().subscribe(childFunctionForUser => {
            this.childModuleSendSignalEvents = childFunctionForUser;
        });
    }

    ngOnInit() {
        this.freeLineBotID = +this.constantModules.freeLineBotID;
        this.arrData = this.constantModules.modules;

        this.categoryMoneyAlls = this.categoryMoneyService.getAll();
        this.loading = true;
        this.modulesService.get(this.id).subscribe(data => {
            this.model.name = data.module_name;
            this.model.money = data.money;
        }, error => {
        }, () => {
            this.loading = false;
        });

        let self = this;
        self.getLineBot.subscribe(res => {
            res.forEach(item => {
                if (item.id !== self.freeLineBotID) {
                    let keyLine = 'LINE' + item.id;
                    let existLine = Object.keys(self.arrData).some(function (key) {
                        return self.arrData[key].value == keyLine;
                    });
                    if (!existLine) {
                        let objLineBot = {
                            value: keyLine,
                            name: item.linebot_channel_name + ' (BitLion)'
                        };
                        self.arrData.push(objLineBot);
                    }
                }
            });
            self.checkShowChildModuleSendSignalEvent(self.arrDataModule);
        });

        this.lineBotService.getLineBot().subscribe(res => {
            res.forEach(item => {
                let keyIOS = 'IOS' + item.id;
                let exist = Object.keys(self.arrData).some(function (key) {
                    return self.arrData[key].value == keyIOS;
                });
                if (!exist) {
                    let objIos = {
                        value: keyIOS,
                        name: item.linebot_channel_name + ' (BitLion iOSアプリ)'
                    };
                    self.arrData.push(objIos);
                }
            });
        });

        this.telegramChannelService.getTelegram().subscribe(res => {
            res.forEach(item => {
                let keyTelegram = 'TELEGRAM' + item.id;
                let existTelegram = Object.keys(self.arrData).some(function (key) {
                    return self.arrData[key].value == keyTelegram;
                });
                if (!existTelegram) {
                    let objTelegram = {
                        value: 'TELEGRAM' + item.id,
                        name: item.name_telegram_channel + ' (Telegram)'
                    };
                    self.arrData.push(objTelegram);
                }
            });
        });
    }

    checkedBox(value) {
        return this.arrDataModule.indexOf(value) !== -1;
    }

    selectedBox(value) {
        return this.categoryMoney == value;
    }

    toggleSelect() {
        if ($('#select-checkbox').is(':checked')) {
            $('.checkbox').prop('checked', true);
            for (var i = 0; i < this.arrData.length; i++) {
                this.arrDataModule.push(this.arrData[i].value);
            }
        } else {
            this.arrDataModule = [];
            $('.checkbox').prop('checked', false);
        }

        this.checkShowChildModuleSendSignalEvent(this.arrDataModule);
    }

    selectChecked(value) {
        let checkExits = this.checkedBox(value);
        if (checkExits) {
            let idx = this.arrDataModule.indexOf(value);
            this.arrDataModule.splice(idx, 1);
        } else {
            this.arrDataModule.push(value);
        }

        this.checkShowChildModuleSendSignalEvent(this.arrDataModule);
    }

    ngAfterViewInit() {
        let self = this;
        setTimeout(() => {
            this.focusEventEmitter.emit(true);
            self.checkShowChildModuleSendSignalEvent(this.arrDataModule);
        }, 3000);
    }

    edit() {
        if ($.unique(this.arrDataModule).length == 0) {
            $("label.failure").fadeIn(300).delay(3000).fadeOut(400);
            return false;
        }
        this.loading = true;
        this.message = '';
        this.model.id = this.id;
        this.model.dataModuleFunction = $.unique(this.arrDataModule);
        this.model.categoryMoney = $('#categoryMoney').val();
        this.model.sendSignalFunctionPrices = this.getObjectFunctionSendPriceForUser();

        this.modulesService.edit(this.model).subscribe(data => {
            if (data.error) {
                this.message = data.message;
            } else {
                this.close();
                this.result = true;
            }
        }, error => {
            this.message = error.json().message;
            this.loading = false;
        }, () => {
            this.loading = false;
        })
    }

    checkShowChildModuleSendSignalEvent(checkModule?: any[]) {
        let self = this;
        self.childModuleSendSignalEvents.forEach((element, index) => {
            // Line bot free
            if (element.isFree == true) {
                element.nameLineBot = 'Line Bot Free (BitLion)';
                element.isCheckLineBot = true;
            } else {
                // Line bot not free
                if (checkModule && checkModule.length) {
                    let keyToUpperCase = element.key.toUpperCase();
                    let obj = self.arrData.find((obj) => {
                        return obj.value === keyToUpperCase
                    });
                    if (checkModule.indexOf(keyToUpperCase) !== -1 && obj) {
                        element.nameLineBot = obj.name;
                        element.isCheckLineBot = true;
                    } else {
                        element.isCheckLineBot = false;
                    }
                } else {
                    element.isCheckLineBot = false;
                }
            }
        });

        self.childModuleSendSignalEvents.forEach((element, index) => {
            if (element.isCheckLineBot == true && self.booleanSendSignalEvent == false) {
                self.booleanSendSignalEvent = true;
            }
        });
    }

    changeChildModulePriceEdit(event: any, lineBotID) {
        $('#btn-show-' + lineBotID).attr({disabled: event.target.value ? false : true});
    }

    openModalShowCoinPrice(event: any, lineBotID: any) {
        let self = this;
        let codeSendSignalEvent = $('#select-show-' + lineBotID + ' option:selected').val();
        this.sendSignalService.postListCoinNameActive({codeSendSignalEvent: codeSendSignalEvent}).subscribe((resListCoinName: Response) => {
            self.objPopUp = {
                titlePopup: 'ユーザーにプライスを送信するコインの表示',
                listCoinSendSignal: resListCoinName,
            };
            this.dialogService.addDialog(PopupShowListCoinComponent, self.objPopUp).subscribe((isAccess) => {
            });
        });
    }

    getObjectFunctionSendPriceForUser() {
        let self = this;
        let objPrice = self.childModuleSendSignalEvents.map((element, index) => {
            let tmpObjPrice = {};
            let valueCode = $('#select-show-' + element.lineBot).is(':hidden')
                ? ''
                : ($('#select-show-' + element.lineBot + ' option:selected').val() || '');
            tmpObjPrice['codeFunctionPrice'] = valueCode.length ? valueCode : null;
            tmpObjPrice['lineBotPrice'] = element.lineBot;
            return tmpObjPrice;
        });

        return objPrice
    }

    checkedOptionUser(valueCheck: any, lineBotID: any) {
        let self = this;
        return Object.keys(self.functionSendSignalPrice).some(function (k) {
            $('#btn-show-' + lineBotID).attr({disabled: (($('#select-show-' + lineBotID + ' option:selected').val() || '').length ? false : true)});
            return self.functionSendSignalPrice[k].codeFunctionPrice == valueCheck;
        });
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/modules/edit-modules/edit-modules.component.ts